import {
  Text,
  Box,
  VStack,
  Image,
  HStack,
  LinkBox,
  LinkOverlay,
  Heading,
  Badge,
  Flex,
  SimpleGrid,
  Spinner,
  Link
} from '@chakra-ui/react'
import React, { FC, useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { DashboardLayout } from '../../components'
import useDashboardStore from '../../state/Dashboard.store'
import { money } from '../../utils/formatter'
import { IPolicy } from '../../types'
import { ROUTES } from '../../contants'

const Quotes = () => {
  const [loading, quotes, getQuotes, quotePageInfo] = useDashboardStore((state) => [
    state.loading,
    state.quotes,
    state.getQuotes,
    state.quotePageInfo
  ])

  useEffect(() => {
    getQuotes()
  }, [getQuotes])

  return (
    <DashboardLayout title="Quotes">
      {loading === 'loading' ? (
        <VStack h="100%" justify="center" flex={1}>
          <Spinner size="xl" />
        </VStack>
      ) : loading === 'success' || loading === 'updating' ? (
        quotes?.length ? (
          <SimpleGrid columns={2} spacing={10}>
            {quotes?.map((quote: IPolicy) => (
              <BuyBox
                key={quote.id}
                id={quote.id}
                time={quote.product.period}
                src={`/images/buy-${quote.policy_type === 'vehicle' ? 'car' : 'gadget'}.png`}
                amount={quote.amount}
                title={`${quote.policy_type === 'gadget' ? 'Gadget' : 'Motor'} Insurance`}
                description={
                  quote[quote.policy_type].make
                    ? `${quote[quote.policy_type].make} ${quote[quote.policy_type].model}`
                    : `${quote[quote.policy_type].model}`
                }
              />
            ))}
          </SimpleGrid>
        ) : (
          <Box
            mt="1rem"
            mb="2rem"
            borderRadius="1.2rem"
            overflow="hidden"
            textAlign="center"
            border="1px dashed #FF1B1B">
            <Image mb="3.2rem" mt="4.2rem" mx="auto" maxW="95px" src="/images/quote.png" />

            <Text color="black">You have no Insurance Quotes!</Text>
            <HStack
              mt="2.4rem"
              justify="center"
              bg="rgba(255, 27, 27,  0.05)"
              py="1.3rem"
              px="3rem">
              <Link
                to={ROUTES.insurance}
                as={RouterLink}
                color="brand.blue"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontWeight="600"
                fontSize="1.2rem"
                _hover={{ border: 'none', outline: 'none' }}
                _active={{ border: 'none', outline: 'none' }}
                _focus={{ border: 'none', outline: 'none' }}>
                Get a Quote
                <Image ml="0.5rem" src="/icons/arrow.svg" />
              </Link>
            </HStack>
          </Box>
        )
      ) : null}
    </DashboardLayout>
  )
}

export { Quotes }

type Props = {
  title: string
  description: string
  src: string
  amount: number
  time: string
  id: string
}

const BuyBox: FC<Props> = ({ title, description, src, amount, time, id }) => {
  return (
    <LinkBox
      as={VStack}
      pos="relative"
      border="1px solid #F7F7F7"
      borderRadius="1.6rem"
      overflow="hidden"
      boxShadow="0px 4px 12px rgba(154, 160, 166, 0.08)">
      <Box bgPos="center" backgroundSize="cover !important" w="100%" bg={`url(${src})`} h="100px" />
      <Box w="100%" p="1.2rem">
        <Heading fontWeight="500" color="black" fontSize="1.2rem">
          {title}
        </Heading>
        <LinkOverlay fontSize="1rem" as={RouterLink} to={`/quotes/${id}`}>
          {description}
        </LinkOverlay>
        <Heading
          mt="1.9rem"
          fontSize="1.4rem"
          lineHeight="1"
          d="flex"
          alignItems="flex-end"
          color="brand.blue">
          {money(amount)}
          {'  '}
          <Text lineHeight="1" fontSize="1.1rem" fontWeight="400" as="span">
            / {time}
          </Text>
        </Heading>
      </Box>
    </LinkBox>
  )
}
